<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">
            商品列表
            <div class="search-input">
              <Input v-model="cxName" size="small" placeholder="请输入名称搜索" search />
            </div>
          </div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Button type="primary" icon="md-add" @click="$router.push('/shop/add')"
                style="margin-right: 10px">添加商品</Button>
             <Button type="warning" icon="logo-buffer" @click="$router.push('/sales/discount')">管理活动</Button>
            </div>
            <div v-if="data.length == 0 && !load">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Alert show-icon v-if="$store.state.isMobile">移动设备请左右滑动翻阅</Alert>

              <Row :gutter="24">
                <div class="demo-spin-container" v-if="load">
                  <Spin fix></Spin>
                </div>
                <Col v-else :xxl="6" :xl="8" :lg="8" :md="12" :sm="24" :xs="24" class="ivu-mb" v-for="item in data"
                  :key="item.id">
                <Card class="list-goods-list-item">
                  <p slot="title">
                    {{ item.name }}
                  </p>
                  <p slot="extra">
                    <i-switch v-model="item.status" :true-value="1" :false-value="0"
                      @on-change="statusChange(item.id, item.status)" />
                  </p>
                  <div class="cont">
                    <p><span class="label">商品ID：</span>{{item.id}}</p>
                    <p><span class="label">销量：</span>{{item.sales}}</p>
                    <p><span class="label">一口价：</span>{{item.price}}</p>
                    <img :src="item.front" alt="">
                  </div>
                  <div class="foot">
                    <Button type="primary" size="small" style="margin-right: 5px"
                      @click="$router.push(`/shop/add/${item.id}`)">编辑</Button>
                    <Button type="error" size="small" @click="del(item.id)">删除</Button>
                  </div>
                </Card>
                </Col>
              </Row>

              <div class="paging">
                <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getShop,
    getGroup,
    putShopStatus,
    delShop
  } from "@/api/admin";
  export default {
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        total: "",
        cxName: "",
        loading: false,
     
        data: [],
        load: true
      };
    },

    created() {
      this._getData();
    },
    watch: {
      cxName(newVal, oldVal) {
        if (newVal != oldVal) {
          (this.pageIndex = 1), (this.load = true), this._getData();
        }
      },
    },
    methods: {
      // 获取列表
      _getData() {
        getShop({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          name: this.cxName,
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
          this.Selection = [];
          this.load = false
        });
      },
     
      // 修改状态
      statusChange(id, status) {
        putShopStatus({
          id,
          status,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: status ? "已上架" : "已下架",
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
        });
      },

      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除商品将同时删除商品规格及库存，删除后无法恢复，是否继续？",
          onOk: () => {
            this.delFunction(id);
          },
        });
      },
      // 删除所选
      allDel() {
        let arr = [];
        this.Selection.map(function (item) {
          arr.push(item.id);
        });
        this.del(arr);
      },
      // 删除方法
      delFunction(id) {
        this.loading = true
        this.load = true
        delShop({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading = false
          this.Selection = [];
        });
      },

      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this.load = true
        this._getData();
      },
      pageSizeChange(val) {
        this.pageIndex = 1
        this.pageSize = val;
        this.load = true
        this._getData();
      },
     
    },
  };
</script>

<style lang="less" scoped>
  // th {
  //   background: #ffffff;
  // }
  .list-goods-list-item {
    margin-bottom: 15px;

    /deep/.ivu-card-head p {
      font-size: 16px;
      font-weight: 600;
      color: #000000;
      width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .cont {
      position: relative;

      img {
        width: 92px;
        height: 92px;
        position: absolute;
        right: 0;
        top: 0;
        vertical-align: middle;
        border-radius: 5px;
      }

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .label {
          display: inline-block;
          width: 60px;
          text-align: justify;
          text-align-last: justify;
        }
      }

      p .label:after {
        content: " ";
        display: inline-block;
        text-align: justify;
        width: 100%;
        height: 0px;
      }

      .name {
        font-size: 16px;
        font-weight: 600;
        color: red;
      }


    }

    .foot {
      margin-top: 5px;
    }


  }

  .demo-spin-container {
    display: block;
    width: 200px;
    height: 300px;
    margin: 0 auto;
    position: relative;
  }
</style>